module.exports = __webpack_public_path__ + "static/cannabinoids_graphic-833af3595054ea62d8b239a5a29def8e.png";